/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable no-plusplus */

import isString from 'lodash/isString';
import isUndefined from 'lodash/isUndefined';
import isNumber from 'lodash/isNumber';
import { SerializablePathMaps, ValidationErrorT, PayloadFormFieldT } from '../types';

export const SECTION_RELATED_PROPS = ['section', 'sectionTitle', 'parentSection', 'parentSectionTitle'];

interface ResolvedError {
  targetId?: string; // The Component ID (UUID, Section Alias, or undefined for Root)
  innerPath: string; // The specific property path (e.g., "text.en" or "options.3")
  fullPath: string; // The original joined path for unique identification
}

/**
 * Finds the Section ID (Alias) for a given Field ID.
 * If the field is at the root (no section), it returns undefined.
 */
export const getSectionIdByFieldId = (pathMaps: any, fieldId: string): string | undefined => {
  // Option 1: Direct lookup if you have a flat fieldToSection map
  if (pathMaps.fieldToSection && pathMaps.fieldToSection[fieldId]) {
    return pathMaps.fieldToSection[fieldId];
  }

  // Option 2: Fallback - Search through the schemaSignature if fieldToSection isn't flat
  // This looks for the fieldId inside the 'fields' array of each section
  const sectionEntry = Object.entries(pathMaps.schemaSignature || {}).find(([_, section]: [string, any]) => {
    return section.fields && section.fields.includes(fieldId);
  });

  return sectionEntry ? sectionEntry[0] : undefined;
};

/**
 * Returns the section that contains the field's immediate section.
 * Field -> Section (Immediate) -> Section (Parent/Next Up)
 */
export const getParentSectionIdOfField = (pathMaps: any, fieldId: string): string | undefined => {
  // 1. Get Immediate Section (Section 3)
  const immediateSectionId = pathMaps.fieldToSection?.[fieldId];

  if (!immediateSectionId) return undefined;

  // 2. Get the Next Up Section (Section 2)
  // This uses the section-to-section mapping
  const nextUpSectionId = pathMaps.sectionToSection?.[immediateSectionId];

  return nextUpSectionId;
};

function getLastObjectValues(arr: (string | number)[]): (string | number)[] {
  const optionsListIndex = arr.findIndex((v) => v === 'optionList');
  if (optionsListIndex >= 0) {
    return arr.slice(optionsListIndex + 1);
  }
  for (let i = arr.length - 2; i >= 0; i--) {
    if (isString(arr[i]) && !isUndefined(arr[i + 1])) {
      return arr.slice(i);
    }
  }
  return arr; // fallback: return full array if no container found
}

export const resolveErrorStructure = (error: ValidationErrorT, pathMaps: SerializablePathMaps): ResolvedError | null => {
  const { path: errorPath, questionId } = error;
  const rootKey = errorPath[0] as string;

  if (rootKey !== 'questions') {
    return {
      innerPath: errorPath.join('.'),
      fullPath: errorPath.join('.'),
    };
  }

  function findCommonValue(a: string[], b: (string | number)[]): string | undefined {
    const setB = new Set(b.map(String)); // convert all to strings
    return a.find((v) => setB.has(v));
  }

  const isSectionRelated = findCommonValue(SECTION_RELATED_PROPS, errorPath);
  const isParentSection = isSectionRelated?.toLowerCase()?.includes('parent');
  let finalTargetId: string | undefined = questionId;

  if (isSectionRelated && questionId) {
    if (isParentSection) {
      finalTargetId = getParentSectionIdOfField(pathMaps, questionId);
    } else {
      finalTargetId = getSectionIdByFieldId(pathMaps, questionId);
    }
  }

  // if(payload.length > 0 && errorPath.includes('')) {

  // }

  return {
    targetId: finalTargetId,
    innerPath: getLastObjectValues(errorPath).join('.'),
    fullPath: errorPath.join('.'),
  };
};

export const getQuestionIdFromPath = (questions: PayloadFormFieldT[], path: (string | number)[]): string | undefined => {
  const currentQuestionIndex = path[1];

  // Guard clause for root-level or non-question errors
  if (path[0] !== 'questions' || !isNumber(currentQuestionIndex)) return undefined;

  let currentField = questions[currentQuestionIndex];

  // We start looking at the path from index 2 onwards
  for (let i = 2; i < path.length; i++) {
    const segment = path[i];

    // If we encounter a follow-up list, move the pointer to that nested question
    if (segment === 'followUpQuestionList' && currentField?.followUpQuestionList?.length) {
      const nextIndex = path[i + 1];
      if (isNumber(nextIndex)) {
        currentField = currentField?.followUpQuestionList?.[nextIndex];
        i++; // Skip the index segment in the next loop iteration
      }
    }
    // If the segment is 'text', 'label', etc., we've reached the property of currentField
    else if (isString(segment) && currentField) {
      break;
    }
  }

  return currentField?.id;
};

/**
 * Main function to process the error array
 */
export const attachQuestionIdsToErrors = (payload: any, errors: any[]) => {
  return errors.map((error) => {
    const questionId = getQuestionIdFromPath(payload.questions, error.path);

    if (questionId) {
      return { ...error, questionId };
    }

    return error;
  });
};
